module.exports = __webpack_public_path__ + "img/selected1-min.cf48655b.png";